// StrictMode in dev runs effects twice; stop() aborts an in-flight start()
// so the first run doesn't leak a context.

import { useEffect } from "react";
import { createUspInstance } from "lib/usp/api";
import useGetFeatureFlags from "./useGetFeatureFlags";

const useUspFlow = (flowName: string): void => {
  const { data: flags } = useGetFeatureFlags();
  const enabled = flags?.["ciam-pim_sardine_enabled"] === true;

  useEffect(() => {
    if (!enabled) {
      return;
    }
    const instance = createUspInstance();
    void instance.start(flowName);
    return () => {
      instance.stop();
    };
  }, [enabled, flowName]);
};

export default useUspFlow;
